import { Component } from '@angular/core';

@Component({
    selector:'big-title-utility',
    template:"<span style='display:block;font-size:30px;padding:20px 0px;'>Utilities</span>",
})

export class BigTitleComponent {

}


// WEBPACK FOOTER //
// ./src/app/ultilities/utility-txt.ts